import { helpers } from '@vuelidate/validators';

export default function isInArray(arr) {
	return function (value) {
		return !helpers.req(value) || arr.includes(value);
	};
}
